import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap-5';
import IntegrationsModal from './integration_modal';

import calendarIcon from '../images/calendar_integration.svg';
export default class CalendarModal extends React.Component {

  static propTypes = {
    currentDatabase: PropTypes.object,
    databases: PropTypes.array.isRequired,
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  handleSave = (databaseId) => {
    const { onSave } = this.props;
    onSave(databaseId, 'calendar');
  };

  render() {
    const { currentDatabase, shown, databases, onCancel } = this.props;

    return (
      <IntegrationsModal
        calendar
        currentDatabase={currentDatabase}
        databases={databases}
        shown={shown}
        title="Connect Calendar Sync"
        onCancel={onCancel}
        onSave={this.handleSave}
      >
        <div>
          <div className="mb-3 text-center">
            <div className="bg-body-tertiary border rounded p-2 d-inline-flex">
              <Image alt="Calendar integration" height={40} src={calendarIcon} width={40} />
            </div>
          </div>
          <span>
            You are about to sync Buildout Calendar Events with your Google account.
            <br/>
            Below, select what database you would like to sync.
          </span>
        </div>
      </IntegrationsModal>
    );
  }
}
